<template>
  <section id="signup">
    <page-title :title="title"></page-title>
    <div class="signup-content">
      <form @submit.prevent="onSignup" v-on:keyup.enter="onSignup">
        <div class="form-field">
          <label for="email">Name</label>
          <input
            id="name"
            type="text"
            v-model="name"
            :placeholder="nameEg"
            required
            autofocus
          />
        </div>
        <div class="form-field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            v-model="email"
            :placeholder="emailEg"
            required
          />
        </div>
        <div class="form-field">
          <label for="password">Password</label>
          <input id="password" type="password" v-model="password" required />
        </div>
        <div class="form-field-checkbox" @click="checkPoliceiesFailed = false">
          <label> Privacy Policy </label>
          <div class="privacy-policy-field">
            <input
              id="check-policies"
              type="checkbox"
              :class="{ red: checkPoliceiesFailed }"
              v-model="checkPolicies"
              required
            />
            <label for="check-policies">
              I agree to Otti
              <a
                target="_blank"
                href="https://www.iubenda.com/privacy-policy/10740404/legal"
                >Privacy and Cookie Policy</a
              >.
            </label>
          </div>
        </div>
        <div>
          <primary-button :title="signUpText" :act="onSignup"></primary-button>
        </div>
      </form>
      <div class="to-signin">
        {{ toLoginMsg }}<router-link to="/login">{{ toLoginLink }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from "firebase";
import PageTitle from "@/components/PageTitle";
import PrimaryButton from "@/components/shared/PrimaryButton";

import bus from "../bus";

export default {
  name: "signup",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      checkPolicies: false,
      checkPoliceiesFailed: false,
      nameEg: "eg. Emma Austen",
      emailEg: "eg. emma@janeausten.com",
      title: "Sign up",
      signUpText: "Create account",
      toLoginMsg: "Already a member? ",
      toLoginLink: "Log in",
      loaderText: `We are building up your ideas space 🔧\nPlease be patient, great things require time 🤓`,
    };
  },
  components: {
    PageTitle,
    PrimaryButton,
  },
  methods: {
    onSignup: function () {
      if (this.name === "") {
        alert("Please enter a valid name!");
        return;
      }
      if (this.checkPolicies) {
        localStorage.setItem("signup-in-progress", true);
        bus.$emit("show-loader", this.loaderText);
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.saveTemporaryUserData();
          })
          .then(() => {})
          .catch((error) => {
            this.$rollbar.error(error);
            alert("There was an error creating the account. Please try again later.");
            bus.$emit("hide-loader");
          });
      } else {
        this.checkPoliceiesFailed = true;
        alert(
          "Hey! We know... burocracy is tiring. But we really need your consent to our policies to let you in. See you inside!"
        );
      }
    },
    saveTemporaryUserData: function () {
      localStorage.setItem("user-temp-name", this.name);
      localStorage.setItem("user-temp-privacy", this.checkPolicies);
    },
  },
  mounted() {
    bus.$emit("hide-loader");
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

@import "@/styles/form.scss";

.page-title {
  margin-bottom: 40px;
}

.form-field,
.form-field-checkbox {
  margin-bottom: 16px;
}

.form-field > * {
  display: block;
}

.privacy-policy-field {
  position: relative;
}

.primary-button {
  margin-top: top 30px;
  text-align: center;
}

.to-signin {
  margin-top: 16px;
  color: theme.$text-color;
}
.to-signin a {
  font-weight: theme.$font-weight-bold;
  color: theme.$primary-color;
}

[type="checkbox"]:not(:checked) + label,
[type="checkbox"]:checked + label {
  padding-left: 10px;
  cursor: pointer;
}

[type="checkbox"]:not(:checked) + label::before,
[type="checkbox"]:checked + label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1.25em;
  height: 1.25em;
  border: 1px solid theme.$text-secondary-color;
  background: #fff;
  border-radius: 4px;
}

[type="checkbox"]:not(:checked).red + label::before,
[type="checkbox"]:checked.red + label::before {
  content: "";
  border: 2px solid red;
}

[type="checkbox"]:checked + label::after {
  content: "\2713\0020";
  position: absolute;
  top: 0.1em;
  left: 0.14em;
  font-size: 1.3em;
  line-height: 0.8;
  color: #09ad7e;
  transition: all 0.2s;
  font-family: "Lucida Sans Unicode", "Arial Unicode MS", Arial;
}
@media (min-width: 768px) {
  .signup-content {
    padding: 40px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: auto;
    max-width: 450px;
  }

  #signup ~ .loader-drop .loader {
    margin-left: 0;
  }
}
</style>